import { render } from "./ProfileForm.vue?vue&type=template&id=05fb0ef9"
import script from "./ProfileForm.vue?vue&type=script&lang=js"
export * from "./ProfileForm.vue?vue&type=script&lang=js"

import "./ProfileForm.vue?vue&type=style&index=0&id=05fb0ef9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__